<template>
  <v-card
      class="pt-3 px-4 ma-0 oder-box-products"
      :style="{
              background: '#fffbf8',
              border: '1px solid #cccccccc',
              overflow: 'auto',
            }"
      outlined
      tile
  >
    <div class="d-flex  mt-3">
      <div class="pr-3 pl-3" style="width: 200px;color: #ac0606; font-weight: 600; font-size: 14px;margin-top: 2px;">Biên nhận thanh toán</div>
      <div class="d-flex pl-6">
        <v-radio-group @change="handleChangeOrderProduct()" v-model="product.orderTypeProduct" row style="margin: 0 !important; padding: 0 !important;">
          <v-radio label="Tính theo giá cọc" :value="1" color="green" class="pr-3" ></v-radio>
          <v-radio  label="Tính theo giá full" :value="2" color="green"></v-radio>
        </v-radio-group>
      </div>
    </div>
    <v-row>
      <v-col cols="7" class="py-0 pt-2">
        <v-simple-table
            class="table-layout table-order-custom-tutor"
            :style="{  background: '#fffbf8'}">
          <thead>
          <tr>
            <th class="col-package text-left" style="font-size: 12px !important;width: 70% !important;">
              <div class="d-flex">
                <div>SẢN PHẨM COMBO</div>
                <div
                    style="color: #0575ff; cursor: pointer"
                    class="d-flex"
                    @click="viewDetailCombo(product)"
                >
                  <v-icon class="mx-2" style="color: #0575ff"
                  >mdi-information</v-icon
                  ><span class="my-auto">Chi tiết combo</span>
                </div>
              </div>
            </th>
            <th class="col-package text-left" style="font-size: 12px !important">
              ₫ THÀNH TIỀN
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <div class="input-disabled-block">
                {{ product.name }}
              </div>
            </td>
            <td>
              <div class="input-disabled-block">
                {{ product.orderTypeProduct === 2 ?
                  (product.intoMoney ? formatCurrencyNoD_C(product.intoMoney) : 0) :
                  (product.intoMoneyDeposit ? formatCurrencyNoD_C(product.intoMoneyDeposit) : 0)
                }}
              </div>
            </td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>


import {formatCurrencyNoD_C} from "../HelperFunc";

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    indexProd: {
      type: Number,
      default: 0,
    },
    isDetailOrder: {
      type: Boolean,
      default: false,
    },
    innerWidth: {
      type: Number,
      default: 0,
    },
    skuTutors: {
      type: Array,
      default: () => [],
    },
    orderId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      productClone: {},
    };
  },
  created() {
    this.productClone = _.cloneDeep(this.product)
  },
  methods: {
    handleChangeOrderProduct() {
      this.$emit('productUpdated', {
        product: this.product,
        index: this.indexProd
      });
    },
    formatCurrencyNoD_C,
    viewDetailCombo(product) {
      this.$emit("viewDetailCombo", product);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep input[type=number]::-webkit-inner-spin-button,
::v-deep input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Cho Firefox */
::v-deep input[type=number] {
  -moz-appearance: textfield;
}

::v-deep.v-input__control {
  min-height: 10px;
}

::v-deep .v-data-table th {
  font-size: 16px !important;
}
::v-deep .v-data-table td,
::v-deep .v-data-table table thead tr th {
  font-size: 14px !important;
  padding: 10px 12px !important;
  padding-bottom: 0 !important;
}

.price {
  background: #d9d9d9;
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 5px;
  font-weight: 400;
  height: 38px;
  line-height: 28px;
  border-radius: 4px;
}
::v-deep
.v-text-field--outlined.v-input--dense.v-text-field--outlined
> .v-input__control
> .v-input__slot {
  min-height: 38px !important;
}

.table-order-custom {
  .col-program {
    width: 12%;
  }
  .col-package {
    width: 12%;
  }
  .col-product {
    width: 12%;
  }
  .col-price {
    width: 12%;
  }
  .col-discount {
    width: 12%;
  }
  .col-total {
    width: 12%;
  }
  .col-child {
    width: 12%;
  }
}

.table-order-custom-tutor {
  th {
    min-width: 100px !important;
    padding-bottom: 0 !important;
    height: 24px !important;
  }
  .col-program {
    width: 240px;
  }
  .col-teacher {
    width: 100px;
  }
  .col-package {
    width: 120px;
  }
  .col-product {
    width: 210px;
  }
  .col-count {
    min-width: 60px !important;
    width: 85px !important;
  }
  .col-price {
    width: 150px;
  }
  .col-discount {
    width: 100px;
  }
  .col-total {
    width: 100px;
  }
  .col-child {
    min-width: 120px !important;
    width: 120px !important;
  }
  .text-muted {
    color: #564f4c;
    font-size: 10px;
  }
}
.table-layout {
  th {
    border-bottom: none !important;
  }
}

.select-customer ::placeholder {
  color: rgb(172, 6, 6) !important;
  font-style: italic;
  font-size: 13px;
}

.cursor-pointer {
  cursor: pointer;
}
.input-disabled-block {
  border-bottom: 1px solid #d2d2d2;
  text-align: left !important;
  padding-bottom: 3px;
  color: #495057;
  margin-top: -12px !important;
}
</style>